import { styled } from "@mui/material";

export const StyledAweberForm = styled('div')(() => ({
  display: "none"
}));